(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  class LayeredSlideshowComponent extends HTMLElement {
    constructor() {
      super();
      this.autoRotate = this.dataset.autoRotate === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed) || 5) * 1000;
      this.currentIndex = 0;
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.autoplayTimer = null;
      
      if (this.autoRotate && this.tabs.length > 1) {
        this.startAutoplay();
        this.setupPauseOnHover();
        this.setupManualControl();
      }
    }

    startAutoplay() {
      this.stopAutoplay(); // Clear any existing timer
      this.autoplayTimer = setInterval(() => {
        this.goToNextSlide();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }

    goToNextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.tabs.length;
      this.tabs[this.currentIndex].click();
    }

    setupPauseOnHover() {
      this.addEventListener('mouseenter', () => {
        this.stopAutoplay();
      });
      
      this.addEventListener('mouseleave', () => {
        if (this.autoRotate) {
          this.startAutoplay();
        }
      });
    }

    setupManualControl() {
      // When user manually clicks a tab, reset autoplay timer
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.currentIndex = index;
          if (this.autoRotate) {
            this.startAutoplay(); // Restart timer from this slide
          }
        });
      });
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }
  }

  if (!customElements.get('layered-slideshow-component')) {
    customElements.define('layered-slideshow-component', LayeredSlideshowComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
